// extracted by mini-css-extract-plugin
export default {"wrapper":"AccountMenu_wrapper__SG0M4","userName":"AccountMenu_userName__74N4n","avatar":"AccountMenu_avatar__dlvG0","popover":"AccountMenu_popover__1K8nC"};